<div class="grid-container">
  <div class="esf-accordion esf-accordion--info-tiles">
    <div app-accordion-table
         class="esf-accordion__unit esf-accordion--info-tiles"

         [actionButtons]="actionButtons"
         [accordionHeading]="tablesTranslations.i18nTixxSelect"
         [isPanelOpened]="isPanelOpened"

         [emptyStateIcon]="'#esf-icon-clover-leaf-48'"
         [emptyStateText]="tablesTranslations.i18nNoSubmissions"

         (rowButtonClickEvent)="actionButtonClicked($event)"
         (panelTriggerClickEvent)="isPanelOpenedChange.emit(!isPanelOpened)"
         (rowClickEvent)="viewSubmissionDetails($event)"

         [showAllLink]="'tixx-select'"

         [data]="currentSubmissions"
         [keys]="keys"
         [columns]="columns">
    </div>
  </div>
</div>
